import { Link, useNavigate } from "react-router-dom";
import { XCircle, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { BrandLogo } from "@/components/BrandLogo";

export default function BookingCancel() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-slate-50">
      <header className="bg-white border-b border-slate-200">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <BrandLogo to="/" size="sm" />
        </div>
      </header>

      <main className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
        <div className="bg-white rounded-3xl border border-slate-200 p-9 lg:p-12 shadow-sm text-center">
          <div className="mx-auto w-16 h-16 rounded-2xl bg-amber-50 flex items-center justify-center mb-5">
            <XCircle className="w-8 h-8 text-amber-600" />
          </div>
          <h1 className="font-display text-2xl lg:text-3xl font-bold text-slate-900">Payment cancelled</h1>
          <p className="mt-2 text-slate-600">No worries — your booking wasn't completed and no charge was made. You can try again whenever you're ready.</p>
          <div className="mt-7 flex justify-center gap-3">
            <Button onClick={() => navigate("/book")} size="lg" className="rounded-full btn-aqua">
              Restart booking <ArrowRight className="w-4 h-4 ml-1.5" />
            </Button>
            <Button onClick={() => navigate("/")} size="lg" variant="outline" className="rounded-full">
              Back to home
            </Button>
          </div>
        </div>
      </main>
    </div>
  );
}
